<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Centre"><span><a id="auto_bookmark_table_of_contents_1"></a><img alt="" id="Kindle" src="Kindle.jpg" style="max-width:100%; max-height:100%; "/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0008.vue?5c92ec82